import { SelectOption } from 'ui';

export enum Frequency {
  NEVER = 'never',
  EVERY_DAY = '1_3',
  EVERY_WEEK = '1_2',
  EVERY_MONTH = '1_1',
  EVERY_3_MONTH = '3_1',
  EVERY_6_MONTH = '6_1',
  EVERY_YEAR = '1_0',
}

export enum Days {
  FIRST_MONDAY = '1_0',
  FIRST_TUESDAY = '1_1',
  FIRST_WEDNESDAY = '1_2',
  FIRST_THURSDAY = '1_3',
  FIRST_FRIDAY = '1_4',
  FIRST_SATURDAY = '1_5',
  FIRST_SUNDAY = '1_6',
}

export const frequencyOptions: SelectOption<Frequency>[] = [
  { value: Frequency.NEVER, label: 'Never' },
  { value: Frequency.EVERY_DAY, label: 'Every day' },
  { value: Frequency.EVERY_WEEK, label: 'Every week' },
  // { value: Frequency.EVERY_MONTH, label: 'Every 1 month' },
  // { value: Frequency.EVERY_3_MONTH, label: 'Every 3 month' },
  // { value: Frequency.EVERY_6_MONTH, label: 'Every 6 month' },
  // { value: Frequency.EVERY_YEAR, label: 'Every year' },
];

export const daysOptions: SelectOption<Days>[] = [
  { value: Days.FIRST_MONDAY, label: 'Monday' },
  { value: Days.FIRST_TUESDAY, label: 'Tuesday' },
  { value: Days.FIRST_WEDNESDAY, label: 'Wednesday' },
  { value: Days.FIRST_THURSDAY, label: 'Thursday' },
  { value: Days.FIRST_FRIDAY, label: 'Friday' },
];

export const datesOptions: SelectOption<number>[] = Array(31)
  .fill(null)
  .map((_, index) => ({
    value: index + 1,
    label: index + 1,
  }));
